import { Button } from "./ui/button";

export function ButtonLink({ children, href }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className="w-full">
      <Button className="w-full cursor-pointer">
        {children}
      </Button>
    </a>
  );
}
